<template>
  <input 
    type="color" 
    ref="input" 
    :value="value" 
    @input="$emit('input', $refs.input.value)"
  >
</template>

<script>
export default {
  name: 'iColorField',
  props: ['value'],
};
</script>

